<template>
    <div>
        <div v-if="currentPage === 'intro'" class="z-10 bg-white">
            <DesignPriceIntro :design-price-product="designPriceProduct" />
        </div>
        <div v-if="currentPage === 'sticker'" class="z-20 bg-white">
            <DesignPriceSticker :design-price-sticker="designPriceSticker" />
        </div>
        <div v-if="currentPage === 'package'" class="z-20 bg-white">
            <DesignPricePackage :design-price-package="designPricePackage" />
        </div>
    </div>
</template>

<script setup lang="ts">
import {
    DesignPricePackageType,
    DesignPriceProductType,
    DesignPriceStickerType,
} from '@/types/DesignPriceType';
import DesignPriceIntro from '~/components/design-price/DesignPriceIntro.vue';
import DesignPricePackage from '~/components/design-price/DesignPricePackage.vue';
import DesignPriceSticker from '~/components/design-price/DesignPriceSticker.vue';

const props = defineProps<{
    hash: string;
    designPriceProduct: DesignPriceProductType;
    designPricePackage: DesignPricePackageType;
    designPriceSticker: DesignPriceStickerType;
}>();

const currentPage = ref<'intro' | 'sticker' | 'package'>('intro');

watch(
    () => props.hash,
    (newHash) => {
        if (!newHash) {
            currentPage.value = 'intro';
            return;
        }

        if (newHash === '#sticker') {
            currentPage.value = 'sticker';
        } else if (newHash === '#package') {
            currentPage.value = 'package';
        } else {
            currentPage.value = 'intro';
        }
    },
    { immediate: true },
);
</script>
